var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectorDisabled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 47,
    height: 47,
    rx: 11,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 47,
    height: 47,
    rx: 11,
    stroke: "#C4C4C4",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9057 12.4336H25.7311V10.2704C25.7311 10.1217 25.608 10 25.4575 10H23.5425C23.392 10 23.2689 10.1217 23.2689 10.2704V12.4336H11.0943C10.489 12.4336 10 12.9169 10 13.5151V31.0908C10 31.6891 10.489 32.1724 11.0943 32.1724H23.2825V33.254L17.6467 36.9077C17.6167 36.9269 17.5909 36.9518 17.5707 36.981C17.5506 37.0101 17.5364 37.0429 17.5291 37.0774C17.5218 37.112 17.5215 37.1476 17.5281 37.1823C17.5348 37.217 17.5484 37.25 17.568 37.2795L18.6042 38.8748C18.6863 38.9999 18.8573 39.0371 18.9838 38.956L24.5 35.38L30.0162 38.956C30.1427 39.0371 30.3137 39.0033 30.3958 38.8782L31.432 37.2795C31.4709 37.2198 31.4845 37.1472 31.4698 37.0777C31.4551 37.0081 31.4132 36.947 31.3533 36.9077L25.7311 33.2641V32.1724H37.9057C38.511 32.1724 39 31.6891 39 31.0908V13.5151C39 12.9169 38.511 12.4336 37.9057 12.4336ZM36.5377 29.7389H12.4623V14.8671H36.5377V29.7389Z",
    fill: "#FDF6E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4623 29.7389H36.5377V14.8671H12.4623V29.7389Z",
    fill: "#DBDBDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectorDisabled);
export default __webpack_public_path__ + "static/media/projector_disabled.f02d236011a197c5cb0742c12742aaea.svg";
export { ForwardRef as ReactComponent };